import React from "react";
import "../../css/legal.scss";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const Legal = () => {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div>
      <Header />

      <main className="legal_main_box">
        <section id="norm">
          <h1
            data-gtm-vis-recent-on-screen9678464_101={79}
            data-gtm-vis-first-on-screen9678464_101={80}
            data-gtm-vis-total-visible-time9678464_101={100}
            data-gtm-vis-has-fired9678464_101={1}
          >
            特定商取引法に基づく表示
          </h1>
          <div className="description">
            READYFOR株式会社（以下「当社」といいます。）がクラウドファンディングサービス「READYFOR」及び継続寄付サービス（以下「本サービス」と総称します。）で提供している役務等についてご案内いたします。
            <br />
            ※クラウドファンディングサービス「READYFOR」における支援の募集及び継続寄付サービスにおける寄付の募集を総称し、「支援・寄付の募集」といいます。
            <br />
            ※「販売業者等」に該当するクラウドファンディングの実行者が支援者に提供する商品・サービス等に関する表示については、下記【クラウドファンディングに関する表示】をご確認ください。
            <br />
          </div>
          <div className="paragraph">
            <h2>基本情報</h2>
            <div className="body">
              事業者 READYFOR株式会社
              <br />
              販売責任者 米良はるか
              <br />
              住所 東京都千代田区一番町8　住友不動産一番町ビル7階
              <br />
              お問合せ先{" "}
              <Link onClick={toTop} to="/">
                www.readyfor.jp
              </Link>
              <br />
              電話番号：050-1746-9680（受付時間：土日祝日年末年始を除く平日10〜17時）
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>本サービスについて</h2>
            <div className="body">
              <br />
              <span style={{ fontSize: "110%" }}>
                {" "}
                〈クラウドファンディングサービス〉
              </span>
              <br />
              実行者がクラウドファンディングを実施して支援者から支援を受け付け、支援者がクラウドファンディングに対する支援を行い、また、実行者と支援者が交流する場や機会を提供するサービスです。
              <br />
              <br />
              <span style={{ fontSize: "110%" }}>〈継続寄付サービス〉</span>
              <br />
              寄付募集者が継続的に実施する事業の活動費を調達する目的で寄付募集を実施して寄付者から寄付を受け付け、寄付者がこれに対する寄付を行い、また、寄付募集者と寄付者が交流する場や機会を提供するサービスです。
              <br />
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>サービスの提供時期</h2>
            <div className="body">
              <br />
              支援・寄付の募集の実施及び支援・寄付の受付けに係るサービス提供は、原則として実行者・寄付募集者が支援・寄付の募集を実施する間（クラウドファンディングにおいては支援募集期間の満了まで）提供されます。
              <br />
              <br />
              なお、活動報告、メッセージ機能その他の当社所定の一部機能に関しては、支援・寄付の募集の実施終了後もご利用いただけます。
              <br />
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>サービスの対価・支払方法</h2>
            <div className="body">
              <br />
              <span style={{ fontSize: "110%" }}>
                {" "}
                〈クラウドファンディングサービス〉
              </span>
              <br />
              1．実行者が支払う対価・支払方法
              <br />
              実行者は、クラウドファンディングが成立した場合、当社と実行者との間で締結されるクラウドファンディングサービスの利用に関する契約（以下「実行者契約」といいます。）の定めに従い、当社に対してクラウドファンディング実施手数料を支払うものとします。
              <br />
              当該手数料の支払いは、原則として、当社が実行者に引き渡す支援金から当該手数料相当額を控除することにより行われます。
              <br />
              なお、クラウドファンディングが成立した場合の支援金の引渡しは、原則として、支援募集期間の満了日の属する月の翌々月10日までに行われます。ただし、実行者が早期入金サービスを利用した場合の引渡期日は、支援募集期間の満了日の翌週（ただし、支援募集期間の満了日が土曜日又は日曜日の場合は翌々週）の3営業日目となります。
              <br />
              <br />
              上記のほか、実行者は、クラウドファンディングを中止した場合などにおいて、実行者契約の定めに従い、当社に対し、事務手数料その他の手数料を負担する場合があります。
              <br />
              <br />
              2．支援者が支払う対価・支払方法
              <br />
              (1)支援者システム利用料
              <br />
              支援者がクラウドファンディング(寄付金控除型クラウドファンディングのうち、支援者がふるさと納税に係る税制上の優遇措置を受けることができるものを除きます。また、プロジェクトページの公開開始が
              2022 年 3 月 1
              日以降のものに限ります。)に対する支援を行う場合、当社
              が特別に認める場合を除き、支援者の1回の支援につき220円（税込）の支援者システム利用料が発生いたします。
              <br />
              <br />
              支援者システム利用料は、実行者に対する支援金の支払と同時に、支援金と同様の方法で当社に対し支払われます。
              <br />
              <br />
              「READYFOR利用規約」の定めに従い支援がキャンセルされた場合、支援者システム利用料もキャンセルされます。
              <br />
              <br />
              (2)支援金
              <br />
              なお、支援者が本サービスの利用に際して実行者に対して支払う支援金については、リターンの対価又は寄付金として実行者へ支払われるものであり、当社は代理受領者として支援金を受領するにすぎません。クラウドファンディングに対するご支援に関しては、「READYFOR利用規約」、及び下記【クラウドファンディングに関する表示】をご確認下さい。
              <br />
              <br />
              <span style={{ fontSize: "110%" }}> 〈継続寄付サービス〉</span>
              <br />
              寄付募集者は、当社と寄付募集者との間で締結される継続寄付サービスの利用に関する契約の定めに従い、当社に対して手数料を支払うものとします。
              <br />
              当該手数料の支払いは、原則として、当社が実行者に引き渡す寄付金から当該手数料相当額を控除することにより行われます。
              <br />
              なお、寄付金の引渡しは、原則として、寄付が行われた日の属する月の翌月25日までに行われます。
              <br />
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2> サービス対価以外にユーザーが負担すべき金銭</h2>
            <div className="body">
              本サービスの利用に際して必要となるインターネット接続料金、通信料金等
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>キャンセルについて</h2>
            <div className="body">
              <br />
              <span style={{ fontSize: "110%" }}>
                〈クラウドファンディングサービス〉
              </span>
              <br />
              実行者は、クラウドファンディングの公開後は、事前に当社の承諾を得ない限り、クラウドファンディングを中止することはできません。
              <br />
              なお、実行者がクラウドファンディングを中止する場合、実行者契約の定めに従い、当社に対して事務手数料を負担する場合があります。
              <br />
              <br />
              また、実行者は、サポートプラン又はコンサルティングプランを選択した場合、専任担当者のサポートを受けてクラウドファンディングの公開準備を開始した後に実行者の都合でこれを中止したときは3万円（税別）、クラウドファンディングの公開後に実行者の都合でクラウドファンディングを中止したときは5万円（税別）のキャンセル料を当社に対して負担する場合があります。
              <br />
              <br />
              なお、支援者が行ったクラウドファンディングに対する支援の取消しに関しては、下記「クラウドファンディングに関する表示」の「支援のキャンセルについて」をご確認下さい。
              <br />
              <br />
              <span style={{ fontSize: "110%" }}>〈継続寄付サービス〉</span>
              <br />
              寄付募集者が寄付募集を開始した後に寄付募集の新規停止や終了を行う場合、当社所定の方法により申請し、当社の承認を得る必要があります。
              <br />
              <br />
              また、寄付募集者がマンスリーサポーターキャンペーンを利用する場合、専任担当者のサポートを受けて特設ページの公開準備を開始した後に寄付募集者の都合でこれを中止したときは3万円（税別）、特設ページの公開後に寄付募集者の都合で特設ページ上での継続寄付の募集を中止したときは5万円（税別）のキャンセル料を当社に対して負担する場合があります。
              <br />
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>【クラウドファンディングに関する表示】</h2>
            <div className="body">
              <br />
              支援者がクラウドファンディングに対する支援を行った場合、「READYFOR利用規約」の定めに従い、実行者と支援者との間に支援契約が成立します。実行者は、その責任においてプロジェクトを遂行し、また、支援者に対してリターンを提供するものとします（当社がプロジェクトを遂行し、またはリターンを提供する義務を負うものではありません）。
              <br />
              <br />
              実行者が特定商取引に関する法律上の「販売業者又は役務提供事業者」（以下「販売業者等」といいます。）に当たる場合における、クラウドファンディングに関して実行者が支援者に提供する商品・サービス等の同法上の表示については以下のとおりです。
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>実行者（販売者）の基本情報</h2>
            <div className="body">
              実行者の名称（法人の場合は販売責任者を含みます。）、電話番号、住所はプロジェクトページに準じます。
              <br />
              ※プロジェクトページに記載がない事項については、支援募集期間中に当社（
              <Link onClick={toTop} to="/">
                www.readyfor.jp
              </Link>
              ）又は実行者までお問い合わせ頂いた場合、遅滞なくご案内いたします（ただし、実行者が販売業者等に当たる場合に限ります。）。
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>実行者（販売者）の提供するリターンについて</h2>
            <div className="body">
              リターンの内容、提供時期、リターンの対価についてはプロジェクトページに準じます。
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>リターンの対価のお支払方法について</h2>
            <div className="body">
              原則として、カード決済、銀行振込み及びコンビニ決済。
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>リターンの対価の支払時期</h2>
            <div className="body">
              支援が行われた時点（ただし、カード決済に関してはクラウドファンディングの達成時点で実行されます。）
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>リターンの対価以外にユーザーが負担すべき金銭</h2>
            <div className="body">
              本サービスの利用に際して必要となるインターネット接続料金、通信料金等
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>支援のキャンセルについて</h2>
            <div className="body">
              以下のガイドラインをご確認ください。
              <br />
              <Link onClick={toTop} to="/">
                www.readyfor.jp
              </Link>
              <br />
              なお、実行者によるクラウドファンディングの中止その他何らかの理由により支援者の支援が取り消される場合がありますので、ご了承ください。
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>支援の申込期限</h2>
            <div className="body">
              支援募集期間の満了日まで
              <br />
            </div>
          </div>
          <div className="paragraph">
            <div className="body">
              注：実行者が販売業者等（営利の意思をもって、反復継続して取引を行う者）に該当するかは、実行者の性質、プロジェクト・リターンの性質等に鑑み個別に判断されます。
            </div>
          </div>
          <div className="paragraph">
            <h2>改訂履歴</h2>
            <div className="body">
              2020年12月18日
              <br />
              2021年7月1日
              <br />
              2021年8月16日
              <br />
              2021年11月24日
              <br />
              2022年3月1日
            </div>
          </div>
        </section>
        <ul id="breadcrumbs">
          <li>
            <Link onClick={toTop} to="/">
              ←戻る
            </Link>
          </li>
        </ul>
      </main>

      <Footer />
    </div>
  );
};

export default Legal;
